import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getOffers } from '../../../../../shared/selectors/offers';
import { getUser } from '../../../../../shared/selectors/user';
import { addAdFoxBanner } from '../../../../../shared/serp/components/adfox';
import { shouldSendAdsEvent } from '../../../../../shared/utils/shouldSendAdsEvent';
import { FOfferType } from '../../../../JsonQuery';
import { BannerInFilter } from '../../components/advancedFilters/common/BannerInFilter';
import { selectIsUserAgent } from '../../selectors';
import { useContext } from '../../utils/useContext';
import { useOfferType } from '../../utils/useOfferType';

export function PikBannerInFiltersContainer() {
  const {
    appContext: { makeRequest },
    currentLocation,
    jsonQuery,
  } = useContext();
  const offerType = useOfferType();
  const user = useSelector(getUser);
  const isAgent = useSelector(selectIsUserAgent);
  const offers = useSelector(getOffers);

  const locationId = useMemo(() => {
    if (currentLocation === 'moscow_mo') {
      return 1;
    }
    if (currentLocation === 'spb_lo') {
      return 2;
    }

    return currentLocation.parentId || currentLocation.id;
  }, [currentLocation]);

  const banner = useMemo(() => {
    return addAdFoxBanner({
      type: 'picture_banner',
      key: 'picture_banner',
      makeRequest,
      locationId,
      isAgent,
      realtyUserId: user.isAuthenticated ? user.userId : undefined,
      offer: offers[0],
      shouldSendAdsEvent: shouldSendAdsEvent(jsonQuery),
      isNew: true,
      width: '100%',
      minHeight: '100px',
      postViewAnalyticsData: {
        banner: {
          place: 'offersSerp',
          name: 'Listing_filter_more',
        },
      },
    });
  }, []);

  if (offerType !== FOfferType.FlatNew) {
    return null;
  }

  return <BannerInFilter>{banner}</BannerInFilter>;
}
